import Approute from "./router/Index";
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from '@react-oauth/google';
import WebSocketSessionHandler from "./components/WebSocketSessionHandler";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || "547484151794-tbj5l4rhn7lc5ro4c2o59nvp0mt1bql8.apps.googleusercontent.com";

export default function App(){
  return(
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <WebSocketSessionHandler />
        <Approute/>
        <ToastContainer 
          position="bottom-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          className="!z-[999999]"
        />
      </BrowserRouter>
    </GoogleOAuthProvider>
  )
}